// src/components/blog/blogIcons.ts
import {
  faBrain,
  faCalendarCheck,
  faCity,
  faComments,
  faHandshake,
  faHashtag,
  faLandmark,
  faLanguage,
  faListCheck,
  faMicrophone,
  faMoon,
  faNewspaper,
  faPenNib,
  faRing,
  faScaleBalanced,
  faShieldHalved,
  faShirt,
  faSpellCheck,
  faStopwatch,
  faUserTie,
  faUsers,
  faUtensils,
  faWandMagicSparkles,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { BlogIconName } from '../../types/blogTypes';

/** Typed as a full Record so adding a BlogIconName without an icon fails to compile. */
export const BLOG_ICONS: Record<BlogIconName, IconDefinition> = {
  users: faUsers,
  moon: faMoon,
  handshake: faHandshake,
  'user-tie': faUserTie,
  scale: faScaleBalanced,
  utensils: faUtensils,
  microphone: faMicrophone,
  landmark: faLandmark,
  'pen-nib': faPenNib,
  city: faCity,
  wand: faWandMagicSparkles,
  shield: faShieldHalved,
  brain: faBrain,
  calendar: faCalendarCheck,
  language: faLanguage,
  comments: faComments,
  'spell-check': faSpellCheck,
  checklist: faListCheck,
  stopwatch: faStopwatch,
  shirt: faShirt,
  ring: faRing,
  newspaper: faNewspaper,
  hashtag: faHashtag,
};
